const API_BASE_URL = '/api'

const API_ROUTES = {

    //获取列表
    soccer_list: `${API_BASE_URL}/soccer/list`,

    soccer_info: `${API_BASE_URL}/soccer/info`,
    // 管理员按月份导出正式队员出勤统计
    soccer_attendance_export: `${API_BASE_URL}/soccer/attendance/export`,
    //创建比赛
    game_create: `${API_BASE_URL}/game/create`,
    //获取比赛列表
    game_list: `${API_BASE_URL}/game/list`,
    //获取比赛详情
    game_info: `${API_BASE_URL}/game/info`,
    //获取下拉框人员列表
    soccer_list_down: `${API_BASE_URL}/soccer/list_down`,
    //报名参赛
    game_join: `${API_BASE_URL}/game/join`,
    // 球员本人取消当前比赛的报名、请假或待定记录。
    game_cancelRegistration: `${API_BASE_URL}/game/cancelRegistration`,
    //分队
    game_allocation: `${API_BASE_URL}/game/allocation`,
    //修改位置
    game_changePosition: `${API_BASE_URL}/game/changePosition`,
    //修改信息
    game_changeGameInfo: `${API_BASE_URL}/game/changeGameInfo`,
    //记录比赛信息
    game_event: `${API_BASE_URL}/game/event`,
    //比赛进度信息
    game_eventInfo: `${API_BASE_URL}/game/eventInfo`,
    //首页进行中比赛轻量快照
    game_liveSnapshot: `${API_BASE_URL}/game/liveSnapshot`,
    //获取当前队伍的所有队友
    game_currentTeams: `${API_BASE_URL}/game/currentTeams`,
    //比赛结束按钮
    game_end: `${API_BASE_URL}/game/end`,
    //获取排行榜信息
    game_charts: `${API_BASE_URL}/game/charts`,
    //登录
    member_login: `${API_BASE_URL}/member/login`,
    //查询当前的账号是否存在
    member_exist: `${API_BASE_URL}/member/exist`,
    //修改比赛状态
    game_next: `${API_BASE_URL}/game/next`,
    //修改比赛的队伍颜色和名称
    game_color: `${API_BASE_URL}/game/color`,
    // 内讧赛报名结束后由主队队长一次提交两支队伍名称。
    game_teamNames: `${API_BASE_URL}/game/teamNames`,
    //比赛重新开始
    game_restart: `${API_BASE_URL}/game/restart`,
    //上传照片
    auth_uploadImg: `${API_BASE_URL}/auth/uploadImg`,
    //修改信息
    auth_updateMemberInfo: `${API_BASE_URL}/auth/updateMemberInfo`,
    //管理员一次性维护指定球员的个人档案
    auth_adminUpdateMemberInfo: `${API_BASE_URL}/auth/adminUpdateMemberInfo`,
    //球员本人修改允许开放的个人资料
    auth_updateOwnMemberInfo: `${API_BASE_URL}/auth/updateOwnMemberInfo`,
    //修改密码
    auth_updatePassword: `${API_BASE_URL}/auth/updateMemberPassword`,
    //查询当前人是否有没选mvp的
    game_mvpStatus: `${API_BASE_URL}/game/mvpStatus`,
    //查询当前人当场比赛是否选择mvp
    game_gameMvp: `${API_BASE_URL}/game/gameMvp`,
    //选举mvp
    game_setMvp: `${API_BASE_URL}/game/setMvp`,
    //获取当前的mvp结果
    game_mvpList: `${API_BASE_URL}/game/mvpList`,
    //修改报名人员的位置
    game_update_allow: `${API_BASE_URL}/game/update_allow`,
    //队长确认阵容
    game_captainConfirm: `${API_BASE_URL}/game/captainConfirm`,
    //队长确认阵容
    game_adminConfirm: `${API_BASE_URL}/game/adminConfirm`,
    //修改首发
    game_changeMemberFirst: `${API_BASE_URL}/game/changeMemberFirst`,
    //比赛结束选择鸽子
    game_update_bird: `${API_BASE_URL}/game/update_bird`,
    //获取赛季列表
    season_list: `${API_BASE_URL}/season/list`,
    //插入新赛季
    season_insert: `${API_BASE_URL}/season/insert`,
    //删除赛季
    season_delete: `${API_BASE_URL}/season/delete`,
    //设置为当前赛季
    season_first: `${API_BASE_URL}/season/first`,
    //选择阵型
    game_teamModel: `${API_BASE_URL}/game/teamModel`,
    //确认阵容
    game_firstModel: `${API_BASE_URL}/game/firstModel`,
    //调换队长
    game_captainReturn: `${API_BASE_URL}/game/captainReturn`,
    //审核头像信息
    auth_userInfoList: `${API_BASE_URL}/auth/userInfoList`,
    //审核头像
    auth_auditMemberImage: `${API_BASE_URL}/auth/auditMemberImage`,
    //审核全部头像
    auth_uploadAllImages: `${API_BASE_URL}/auth/uploadAllImages`,
    //修改队员等级
    auth_auditMemberLevel: `${API_BASE_URL}/auth/auditMemberLevel`,
    //修改比赛信息
    game_updateGameInfo: `${API_BASE_URL}/game/updateGameInfo`,
    //修改比赛记录
    game_updateEventInfo: `${API_BASE_URL}/game/updateEventInfo`,
    //修改比赛记录
    game_deleteEventInfo: `${API_BASE_URL}/game/deleteEventInfo`,
    //手动添加比赛记录
    game_addEventInfo: `${API_BASE_URL}/game/addEventInfo`,
    //临时添加人
    game_tempAddMember: `${API_BASE_URL}/game/tempAddMember`,
    //上传图片到OSS
    auth_uploadToOss: `${API_BASE_URL}/auth/uploadToOss`,
    //添加外战队伍
    game_outGameInfo: `${API_BASE_URL}/game/outGameInfo`,
    //添加新成员
    member_addMember: `${API_BASE_URL}/member/addMember`,
    //获取比赛所有人员信息
    team_memberList: `${API_BASE_URL}/team/memberList`,
    //创建队伍
    team_create: `${API_BASE_URL}/team/create`,
    //队伍列表
    team_list: `${API_BASE_URL}/team/list`,
    //当前队伍的详细信息
    team_get: `${API_BASE_URL}/team/get`,
    //给当前的比赛直接添加队伍
    game_addTeam: `${API_BASE_URL}/game/addTeam`,
    //删除一个队伍
    team_delete: `${API_BASE_URL}/team/delete`,
    //活动赛排名
    team_charts: `${API_BASE_URL}/team/charts`,
    //添加队伍中的成员
    team_set: `${API_BASE_URL}/team/set`,
    //删除当前队伍的成员
    team_remove: `${API_BASE_URL}/team/remove`,
    //获取队伍的成员列表
    member_list: `${API_BASE_URL}/member/list`,
    //添加临时队员
    member_addTempMember: `${API_BASE_URL}/member/addTempMember`,
    //添加新临时队员
    member_addNewTempMember: `${API_BASE_URL}/member/addNewTempMember`,
    //重置首发阵容
    game_reset_team_model: `${API_BASE_URL}/game/reset_team_model`,
    //修改默认位置
    auth_updateDefaultLocation: `${API_BASE_URL}/auth/updateDefaultLocation`,
    //修改当前人的职务
    auth_updateStandingMember: `${API_BASE_URL}/auth/updateStandingMember`,
    //按新字段语义修改职务标签、带队资格和队员状态
    auth_updateMemberRole: `${API_BASE_URL}/auth/updateMemberRole`,
    //获取当前人的生日
    game_birthday: `${API_BASE_URL}/game/birthday`,
    //设置副队长
    game_setSubCaptain: `${API_BASE_URL}/game/setSubCaptain`,
    //创建聚餐
    dinner_create: `${API_BASE_URL}/dinner/create`,
    //获取聚餐信息
    dinner_info: `${API_BASE_URL}/dinner/info`,
    //获取单个聚餐详情
    dinner_detail: `${API_BASE_URL}/dinner/detail`,
    //加入聚餐
    dinner_join: `${API_BASE_URL}/dinner/join`,
    //按聚餐id加入聚餐
    dinner_join_by_id: `${API_BASE_URL}/dinner/joinById`,
    //聚餐列表
    dinner_list: `${API_BASE_URL}/dinner/list`,
    //修改聚餐信息
    dinner_update: `${API_BASE_URL}/dinner/update`,
    //年会列表
    gameYear_list: `${API_BASE_URL}/gameYear/list`,
    //年会信息
    gameYear_Info: `${API_BASE_URL}/gameYear/info`,
    //创建年会
    gameYear_yearCreate: `${API_BASE_URL}/gameYear/yearCreate`,
    //创建年会的比赛
    gameYear_create: `${API_BASE_URL}/gameYear/create`,
    //小游戏列表
    gameYear_littleGame: `${API_BASE_URL}/gameYear/littleGame`,
    //小游戏记录
    gameYear_littleRecords: `${API_BASE_URL}/gameYear/littleRecords`,
    //获取当前比赛种的成员列表
    member_gameList: `${API_BASE_URL}/member/gameList`,
    //获取当前对抗信息数据
    game_getCaptainSeasonInfo: `${API_BASE_URL}/game/getCaptainSeasonInfo`,
    //直接交换两个队伍的队员
    game_switchPosition: `${API_BASE_URL}/game/switchPosition`,
    //获取所有比赛的进球信息统计
    game_charts_goal: `${API_BASE_URL}/game/charts_goal`,
    //获取比赛mvp投票详情
    game_mvpDetail: `${API_BASE_URL}/game/mvpDetail`,
    //获取最近的信息
    game_member_fail_info: `${API_BASE_URL}/game/member_fail_info`,
    //修改当前人的为临时人员
    game_update_determined: `${API_BASE_URL}/game/update_determined`,
    //清除缓存
    clear_cache: `${API_BASE_URL}/clearCache`,
    //修改队长接口
    game_updateCaptain: `${API_BASE_URL}/game/updateCaptain`,
    //相册上传
    album_upload: `${API_BASE_URL}/album/upload`,
    //相册列表
    album_list: `${API_BASE_URL}/album/list`,
    //相册单条媒体完整详情
    album_detail: `${API_BASE_URL}/album/detail`,
    //相册审核
    album_audit: `${API_BASE_URL}/album/audit`,
    //相册喜欢/不喜欢
    album_reaction: `${API_BASE_URL}/album/reaction`,
    //相册评论
    album_comment: `${API_BASE_URL}/album/comment`,
    //相册评论列表
    album_comment_list: `${API_BASE_URL}/album/comment/list`,
    //修改相册标签
    album_tag_update: `${API_BASE_URL}/album/tag/update`,
    //修改相册资源基础信息
    album_update: `${API_BASE_URL}/album/update`,
    //相册媒体浏览统计
    album_view: `${API_BASE_URL}/album/view`,
    //相册标签列表
    album_tag_list: `${API_BASE_URL}/album/tag/list`,
    //新增相册标签
    album_tag_add: `${API_BASE_URL}/album/tag/add`,
    //删除相册标签
    album_tag_delete: `${API_BASE_URL}/album/tag/delete`,
    //相册上传比赛下拉框
    album_dropdown_games: `${API_BASE_URL}/album/dropdown/games`,
    //相册上传比赛事件下拉框
    album_dropdown_events: `${API_BASE_URL}/album/dropdown/events`,
    //相册前端直传 OSS 初始化分片上传
    album_multipart_init: `${API_BASE_URL}/album/multipart/init`,
    //相册前端直传 OSS 完成分片上传
    album_multipart_complete: `${API_BASE_URL}/album/multipart/complete`,
    //相册前端直传 OSS 取消分片上传
    album_multipart_abort: `${API_BASE_URL}/album/multipart/abort`,
    //科朋喜事列表
    happy_list: `${API_BASE_URL}/happy/list`,
    //科朋喜事详情
    happy_detail: `${API_BASE_URL}/happy/detail`,
    //新增或修改科朋喜事
    happy_save: `${API_BASE_URL}/happy/save`,
    //删除科朋喜事
    happy_delete: `${API_BASE_URL}/happy/delete`,
    //科朋喜事标签列表
    happy_tag_list: `${API_BASE_URL}/happy/tag/list`,
    //新增科朋喜事标签
    happy_tag_add: `${API_BASE_URL}/happy/tag/add`,
    //删除科朋喜事标签
    happy_tag_delete: `${API_BASE_URL}/happy/tag/delete`,
}

export default API_ROUTES;
